import { createBrowserRouter, Navigate } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { ToastProvider } from '../components/toast.js';
import { AdminCatalogPage } from '../pages/AdminCatalogPage.js';
import { AdminTenantPage } from '../pages/AdminTenantPage.js';
import { AdminTenantsPage } from '../pages/AdminTenantsPage.js';
import { ContactPage } from '../pages/ContactPage.js';
import { HomePage } from '../pages/HomePage.js';
import { LegalPage } from '../pages/LegalPage.js';
import { ProfilePage } from '../pages/ProfilePage.js';
import { SignInPage } from '../pages/SignInPage.js';
import { TeamPage } from '../pages/TeamPage.js';
import { Shell } from './Shell.js';

const router = createBrowserRouter([
  // Öffentlich – ohne Anmeldung erreichbar.
  { path: '/anmelden', element: <SignInPage /> },
  { path: '/impressum', element: <LegalPage doc="impressum" /> },
  { path: '/datenschutz', element: <LegalPage doc="datenschutz" /> },
  { path: '/kontakt', element: <ContactPage /> },
  {
    element: <Shell />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/team', element: <TeamPage /> },
      { path: '/admin', element: <AdminTenantsPage /> },
      { path: '/admin/mandanten/:tenantId', element: <AdminTenantPage /> },
      { path: '/admin/katalog', element: <AdminCatalogPage /> },
      { path: '/profil', element: <ProfilePage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

export function App() {
  return (
    <ToastProvider>
      <RouterProvider router={router} />
    </ToastProvider>
  );
}
